var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import WebSocket from 'ws';
import * as Stream from 'stream';
function request(client, request) {
    return new Promise((resolve, reject) => {
        let isSettled = false;
        const requestId = `${Date.now()}::${Math.random()}`;
        const listener = (data) => {
            try {
                const message = JSON.parse(data.toString('utf8'));
                if (message.requestId === requestId) {
                    if (!isSettled) {
                        isSettled = true;
                        resolve(message);
                    }
                    client.off('message', listener);
                }
            }
            catch (err) {
                if (!isSettled) {
                    isSettled = true;
                    reject(err);
                }
                client.off('message', listener);
            }
        };
        client.on('message', listener);
        client.send(JSON.stringify(Object.assign({ requestId }, request)), err => {
            if (err && !isSettled) {
                reject(err);
                isSettled = true;
            }
        });
    });
}
export class WebSocketSerialPort extends Stream.Duplex {
    constructor(client, path, baudRate) {
        super();
        this.client = client;
        this.path = path;
        this.baudRate = baudRate;
        this.isOpen = false;
        this.binding = null;
        this.responseListener = (response) => {
            if (response.port === this.path) {
                switch (response.cmd) {
                    case 'error':
                        this.emit('error', Error(response.message));
                        break;
                    case 'data':
                        this.emit('data', Buffer.from(response.data));
                        break;
                    case 'closed':
                        this.emit('close');
                        break;
                }
            }
        };
    }
    write(buffer, encoding, callback) {
        let data;
        if (Array.isArray(buffer))
            data = buffer;
        else if (typeof buffer === 'string') {
            if (typeof encoding === 'string') {
                buffer = Buffer.from(buffer, encoding);
            }
            else {
                buffer = Buffer.from(buffer);
            }
        }
        if (Buffer.isBuffer(buffer)) {
            data = buffer.toJSON().data;
        }
        if (!data)
            throw Error('Unsupported message type');
        if (typeof encoding === 'function') {
            callback = encoding;
        }
        request(this.client, { requestId: '', cmd: 'write', port: this.path, data })
            .then(response => {
            if (response.cmd !== 'success')
                throw Error('Enexpected response from server');
            if (callback)
                callback(null, data.length);
        })
            .catch(err => {
            if (callback)
                callback(err, 0);
            else
                this.emit('error', err);
        });
        return false;
    }
    open(callback) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield request(this.client, {
                requestId: '',
                cmd: 'open',
                port: this.path,
                baudRate: this.baudRate,
            });
            if (response.cmd !== 'success')
                throw Error('Unexpected response from server');
            this.client.on('message', this.responseListener);
            this.isOpen = true;
            if (callback)
                callback();
        });
    }
    close(callback) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield request(this.client, {
                requestId: '',
                cmd: 'close',
                port: this.path,
            });
            if (response.cmd !== 'closed' || response.port !== this.path) {
                const error = Error('Unexpected response from server');
                if (callback)
                    callback(error);
                else
                    this.emit('error', error);
            }
            this.client.off('message', this.responseListener);
            this.isOpen = false;
            if (callback)
                callback();
            this.emit('close');
        });
    }
    update() {
        throw Error('unimplemented');
    }
    read() {
        throw Error('unimplemented');
    }
    set() {
        throw Error('unimplemented');
    }
    get() {
        throw Error('unimplemented');
    }
    flush() {
        throw Error('unimplemented');
    }
    drain() {
        throw Error('unimplemented');
    }
    pause() {
        throw Error('unimplemented');
    }
    resume() {
        throw Error('unimplemented');
    }
}
export function createClient(address) {
    const client = new WebSocket(address, 'serialport-net');
    return {
        listPorts: () => __awaiter(this, void 0, void 0, function* () {
            const response = yield request(client, {
                requestId: '',
                cmd: 'listDevices',
            });
            if (response.cmd !== 'listDevices')
                throw Error('Unexpected response from server');
            return response.devices;
        }),
        openPort: (port, options) => __awaiter(this, void 0, void 0, function* () {
            const serialport = new WebSocketSerialPort(client, port, options.baudRate);
            if (options.autoOpen || options.autoOpen === undefined) {
                yield serialport.open();
            }
            return serialport;
        }),
    };
}
